const initialState = {
  status: '',
  isLoading: false,
  error: false,
};

export const AdminDeleteSharedFavouriteReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DELETE_ADMIN_SHARED_FAVOURITE_SUCCESS':
      return {
        ...state,
        status: 'Delete successful',
        isLoading: false,
        error: false,
      };

    case 'DELETE_ADMIN_SHARED_FAVOURITE_ERROR':
      return {
        ...state,
        isLoading: false,
        error: true,
      };

    case 'RESET_DELETE_SHARED_FAVOURITE_FILTER':
      return initialState;

    case 'API_START':
      if (action.payload === 'DELETE_ADMIN_SHARED_FAVOURITE') {
        return { ...state, isLoading: true, error: false };
      }
      return state;

    case 'API_END':
      if (action.payload === 'DELETE_ADMIN_SHARED_FAVOURITE') {
        return { ...state, isLoading: false };
      }
      return state;

    default:
      return state;
  }
};
